import { UIHeading5, Button, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ShowPhone.css';
import { getFormattedPhoneNumber } from '../../../utils/phones';
import { IOfferPhone } from 'shared/types/offers';

interface IShowPhoneProps {
  name?: string | null;
  phones?: IOfferPhone[];
  onClick(): void;
}

export const ShowPhone: React.FC<IShowPhoneProps> = ({ name, phones, onClick }) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);

  const phonesFormatted: string[] = React.useMemo(
    () => (phones ? phones.map(phone => getFormattedPhoneNumber(`${phone.countryCode}${phone.number}`)) : []),
    [phones],
  );

  const handleClickPhone = React.useCallback(() => {
    setPhoneVisible(true);

    onClick();
  }, [onClick]);

  if (!phones || phones.length === 0) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {phoneVisible ? (
        <div className={styles['phone']}>
          <UIText2 key={name}>{name}</UIText2>
          {phonesFormatted.map(phone => (
            <UIHeading5 key={phone}>{phone}</UIHeading5>
          ))}
        </div>
      ) : (
        <Button theme="fill_primary" size="XS" onClick={handleClickPhone}>
          Показать телефон
        </Button>
      )}
    </div>
  );
};
